import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SECRETARIES_REQUEST = 'FETCH_SECRETARIES_REQUEST';
export const SECRETARIES_FAILURE = 'FETCH_SECRETARIES_FAILURE';
export const SECRETARIES_SUCCESS = 'FETCH_SECRETARIES_SUCCESS';

export const fetchSecretaries = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.SECRETARY.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return { type: SECRETARIES_REQUEST }
};

const fetchFailure = (error) => {
    return { type: SECRETARIES_FAILURE, error }
};

const fetchSuccess = (data) => {
    return { type: SECRETARIES_SUCCESS, data }
};